export default {
  init() {
    // JavaScript to be fired on all pages

    /*global FWP:true*/
      /* exported FWP */
      $(document).on('facetwp-loaded', function() {
        var qs = FWP.buildQueryString();
        if ( '' === qs ) { // no facets are selected
            $('.facet-reset').hide();
        }
        else {
            $('.facet-reset').show();
        }
    });

    $(document).on('facetwp-loaded', function() {
      if (FWP.loaded) {
        $('html, body').animate({
          scrollTop: $('.facetwp-template').offset().top - 250,
        }, 500);
      }
    });

    $( '.toggle-filtering' ).click(function() {
      $('.toggle-filtering').toggleClass('is-active');
      $( '.woocommerce-products__filtering' ).toggleClass('show-filtering');
    });


    /* Fixattu navigaatio */
    $(window).scroll(function() {

      var height = $(window).scrollTop();
      var width = $(window).width();

      if ( height  > 20  && width >= 1024) {
        $('.main-header__logo').addClass('outof');
      } else if ( height > 50 && width < 1024) {
        $('.main-header__logo').addClass('fade');
        $('.main-header').addClass('background-transparent');
      } else {
        $('.main-header__logo').removeClass('fade');
        $('.main-header__logo').removeClass('outof');
        $('.main-header__logo-black').removeClass('in');
        $('.main-header').removeClass('background-transparent');
      }
    });

    if($(window).width() >= 1024) {
      $('.nav-primary ul li ul .sub-menu-wrap').each(function() {
        $('.megamenu-container').append('<div id="sub-" class="sub-menu-container">' + $( this ).html() + '<hr class="clear" /></div>')
      });
    }

    if ($(window).width() >= 1024) {
      $('.megamenu').addClass('is-dropdown-submenu-parent');
    }
    else {
      $('.megamenu').removeClass('is-dropdown-submenu-parent');
    }

    $(window).on('resize', function() {
      if ($(window).width() >= 1024) {
        $('.megamenu').addClass('is-dropdown-submenu-parent');
      }
      else {
        $('.megamenu').removeClass('is-dropdown-submenu-parent');
      }
    });



  $( '.megamenu' ).hover(
    function() {
      $('.megamenu-container').addClass( 'is-visible' );
    }, function() {
      $('.megamenu-container').removeClass( 'is-visible' );
    }
  );

  $( '.megamenu-container' ).hover(
    function() {
      $('.megamenu-container').addClass( 'is-visible' );
    }, function() {
      $('.megamenu-container').removeClass( 'is-visible' );
    }
  );


    // $('.specifics-area').hide();
    // $('.show_hide').on('click', function() {
    //   var txt = $('.specifics-area').is(':visible') ? 'Lue lisää' : 'Lue vähemmän';
    //   $('.show_hide').text(txt);
    //   $('.show_hide').toggleClass('bg');
    //   $(this).next('.specifics-area').slideToggle(300);
    // });


    // Tuotekaruselli (slick)
    $('.product-carousel__row').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      focusOnSelect: true,
      infinite: false,
      draggable: true,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
          },
        },
      ],
    });

    $(function() {
      $('.product-card').matchHeight();
    });

    // Match height

    $(function() {
      $('.modal-container__content').matchHeight();
    });

    // Dropdown valikon animointi

    $('#menu-paavalikko').on(
      'show.zf.dropdownmenu', function() {
        var dropdown = $(this).find('.is-dropdown-submenu');
        dropdown.css('display', 'none');
        dropdown.fadeIn('fast');
    });
    $('#menu-paavalikko').on(
      'hide.zf.dropdownmenu', function() {
        var dropdown = $(this).find('.is-dropdown-submenu');
        dropdown.css('display', 'inherit');
        dropdown.fadeOut('fast');
    });


    // Mobiili valikon avaus animaatio

    $('.hamburger').click(function () {
      $('.hamburger').toggleClass('hamburger--active');
      $('.mobile-navigation-container').toggleClass('mobile-navigation-container__open');
      $('html, .main-content').toggleClass('mobile-navigation-open');
    });

    $('.menu-item-has-children > a').click(function () {
      $(this).unbind('click');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js